import { render, staticRenderFns } from "./index.vue?vue&type=template&id=aa85f642&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa85f642",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa85f642')) {
      api.createRecord('aa85f642', component.options)
    } else {
      api.reload('aa85f642', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=aa85f642&scoped=true&", function () {
      api.rerender('aa85f642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/nyukin/index.vue"
export default component.exports